import { inject, provide, Ref } from "vue";

const SELECTIONS_PROVIDE_KEY = "wdlArchiveSelections";
interface IProvideSelections {
    selectedSeason: Ref<string | number>;
    selectedMeeting: Ref<string>;
}

export const useProvidSelections = (object: IProvideSelections) => {
    provide(SELECTIONS_PROVIDE_KEY, object);
};

export const useInjectedSelections = () => inject<IProvideSelections>(SELECTIONS_PROVIDE_KEY);
